export { TranslationNamespaces, PLAYER_DISPLAY_NAME_START, PLAYER_DISPLAY_NAME_END } from './types.ts';
export { getNestedTranslation } from './nested.ts';
export { checkValueIsTranslationObject } from './validation.ts';
export { loopNestedStrings } from './utils.ts';
export { passThroughTranslation } from './passThroughTranslation.ts';
export { emptyTranslation } from './emptyTranslation.ts';
export * from './context.ts';
import englishStrings from './locales/en/strings.json';
export default englishStrings;
export * from './translations.ts';
